import { jsx as _jsx } from "react/jsx-runtime";
import UIButton from 'UIComponents/button/UIButton';
import { FormattedMessage } from 'LearningCenterUI/components/I18n'; // @ts-expect-error dependency missing types

import ContentControlWrapper from 'LearningCenterUI/components/ContentControlWrapper';

const QuizControlBar = ({
  buttonDisabled,
  onClick,
  hasAnsweredCurrentQuestion
}) => /*#__PURE__*/_jsx(ContentControlWrapper, {
  className: "quiz-control-bar",
  children: /*#__PURE__*/_jsx(UIButton, {
    "data-test-id": "quiz-control-bar-button",
    disabled: buttonDisabled,
    onClick: onClick,
    use: "primary",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.quiz.${hasAnsweredCurrentQuestion ? 'next' : 'checkAnswer'}`
    })
  })
});

export default QuizControlBar;